import { AddCircleOutlineRounded, AddCircleRounded } from "@mui/icons-material";
import { Box, useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
  AccordionText,
  CardContainer,
  GridContainerStyled,
  TabsStyled,
  TabStyled,
  TaglineContainer,
  TaglineTitle,
} from "./styles";

export default function SubEmployerFaq() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const isTabletOrMobile = useMediaQuery("(max-width: 1280px)");

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    // const responseApi = await dispatch(fetchEmployerSolutions());

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
    const response = isMalaysia ? content_my : content_sg;

    const { solutions, solutionsCard } = response || {};
    setSolutions(solutions);
    setSolutionsCard(solutionsCard);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Start Hiring with These Benefits Today";
  const buttonColour = "black";
  const posthog = usePostHog();

  function triggerEmployerSignUp() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "solutions",
    });
  }

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
      </div>
    );
  }

  function DynamicAccordion({ items }) {
    const [expanded, setExpanded] = useState([]);

    const handleChange = (panel) => (event, isExpanded) => {
      if (isExpanded) {
        setExpanded((prev) => [...prev, panel]); // allow multiple open
      } else {
        setExpanded((prev) => prev.filter((p) => p !== panel));
      }
    };
    return (
      <>
        {items?.map((item, index) => {
          const isOpen = expanded.includes(index);
          return (
            <AccordionStyled
              key={index}
              expanded={isOpen}
              onChange={handleChange(index)}
            >
              <AccordionSummaryStyled
                expandIcon={
                  isOpen ? (
                    <AddCircleRounded sx={{ fontSize: 48 }} />
                  ) : (
                    <AddCircleOutlineRounded sx={{ fontSize: 48 }} />
                  )
                }
              >
                <AccordionText type={"title"} expanded={isOpen}>
                  {item?.title}
                </AccordionText>
              </AccordionSummaryStyled>
              <AccordionDetailsStyled>
                <AccordionText
                  type={"description"}
                  dangerouslySetInnerHTML={{ __html: item?.description }}
                ></AccordionText>
              </AccordionDetailsStyled>
            </AccordionStyled>
          );
        })}
      </>
    );
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      {solutions?.map((solution, index) => (
        <>
          <TaglineContainer>
            <TaglineTitle
              dangerouslySetInnerHTML={{ __html: solution?.title }}
            ></TaglineTitle>
          </TaglineContainer>
        </>
      ))}

      <CardContainer>
        <TabsStyled
          orientation={isTabletOrMobile ? "horizontal" : "vertical"}
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <TabStyled label="Job Credits" />
          <TabStyled label="Talent Search" />
          <TabStyled label="Social Media Blasts" />
        </TabsStyled>

        <Box sx={{ width: "100%", padding: "0px" }}>
          <CustomTabPanel value={value} index={0}>
            <DynamicAccordion items={solutionsCard[0]?.items} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <DynamicAccordion items={solutionsCard[1]?.items} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <DynamicAccordion items={solutionsCard[2]?.items} />
          </CustomTabPanel>
        </Box>
      </CardContainer>
    </GridContainerStyled>
  );
}
